import { render, staticRenderFns } from "./VeiculosConfirmacaoDados.vue?vue&type=template&id=6a927b7c"
import script from "./VeiculosConfirmacaoDados.vue?vue&type=script&lang=js"
export * from "./VeiculosConfirmacaoDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports